import type { FaireProductEntity } from "../../entity_types/product";

export const p_rrfgdvac4p: FaireProductEntity = {
  token: "p_rrfgdvac4p",
  type: "product",
  name: "Funny Birthday Card 'Rude You're Younger Than Me'",
  brandName: "by BellaBlue",
  imageUrl:
    "https://cdn.faire.com/fastly/2ac4784fdf6bf7e3200841ea6c6a137a11f2b90f3ddba37258319da376601f1d.jpeg",
  priceDollars: 1.15,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/ac4ccd6b62f4c41eb1e88f1e019d4f9493828d3ae0d78778bd61dde2c7d12593.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
